import { useConfig } from '@hummingbirdtechgroup/wings-config';
import { post } from './request';

export type AuthType = {
  displayName: string;
  email: string;
  idToken: string;
  kind: string;
  localId: string;
  registered: boolean;
  refreshToken: string;
  expiresIn: string;
};

const useAuthenticate = () => {
  const { apiUrl } = useConfig();
  return {
    authenticate: (email: string, password: string) =>
      post<AuthType>(apiUrl, '/v1/login', { email, password }),
  };
};
export default useAuthenticate;
